/** IMPORTANT: When adding new variables, they should be added to scripts/deploy_platform.js as well */

export const BRANCH = process.env.NX_PUBLIC_BRANCH || '';
export const BUILD_ID = process.env.NX_PUBLIC_BUILD_ID || 'dev';

export const ENVIRONMENT = process.env.NX_PUBLIC_ENV || 'dev';

const isDev = ENVIRONMENT === 'dev';

function getBaseUrl() {
  if (isDev) {
    return 'localhost:4000';
  }

  if (process.env.NX_PUBLIC_SERVER_URL) {
    return process.env.NX_PUBLIC_SERVER_URL;
  }

  const url = new URL(window.location.href);

  return `api.${url.hostname}`;
}

export const API_URL = `${isDev ? 'http://' : 'https://'}${getBaseUrl()}/api`;
export const WEBSOCKET_URL = `${isDev ? 'ws://' : 'wss://'}${getBaseUrl()}/api/socket`;

// Authentication
export const KINDE_DOMAIN = process.env.NX_PUBLIC_KINDE_DOMAIN || '';
export const KINDE_CLIENT_ID = process.env.NX_PUBLIC_CLIENT_ID || '';

function getRedirectUriBase() {
  const url = new URL(window.location.href);
  return url.origin;
}

export const LOGIN_REDIRECT_URI = getRedirectUriBase() || '';
export const LOGOUT_REDIRECT_URI = getRedirectUriBase() || '';

export const DEMO_OVERRIDE = !!process.env.NX_PUBLIC_DEMO_OVERRIDE;

export const SENTRY_DSN = process.env.NX_PUBLIC_SENTRY_DSN || '';
export const SENTRY_TRACES_SAMPLE_RATE = ENVIRONMENT === 'production' ? 0.1 : 1.0;

// TODO: move to .env
export const MIXPANEL_TOKEN =
  ENVIRONMENT === 'production' ? '86e5697262f93c2a4520965c4565a705' : '8faeb35ae6d58fbc0813f37e5f908bc3';
